import { Validators } from '@angular/forms';

/**
 * Validates a number to be technically in the integer range.
 */
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const integer = Validators.compose([Validators.min(-2147483648), Validators.max(2147483647)])!;
